import React, { useState } from 'react';

const EstimatePage = () => {
  const [inputValue, setInputValue] = useState('');

  const popularCategories = [
    'レポート作成ダッシュボード',
    'ゲーミングプラットフォーム',
    'オンボーディングポータル',
    'ネットワーキングアプリ',
    'ルームビジュアライザー'
  ];

  return (
    <div className="estimate-page" style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #e6e6fa 0%, #ffe6c8 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 20px',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* 大きなグラデーション装飾 */}
      <div style={{
        position: 'absolute',
        top: '10%',
        right: '5%',
        width: '800px',
        height: '800px',
        background: 'radial-gradient(circle, rgba(255, 189, 89, 0.5) 0%, rgba(255, 189, 89, 0) 70%)',
        borderRadius: '50%',
        pointerEvents: 'none'
      }}></div>
      <div style={{
        position: 'absolute',
        bottom: '10%',
        left: '5%',
        width: '800px',
        height: '800px',
        background: 'radial-gradient(circle, rgba(102, 126, 234, 0.5) 0%, rgba(102, 126, 234, 0) 70%)',
        borderRadius: '50%',
        pointerEvents: 'none'
      }}></div>
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '1000px',
        height: '1000px',
        background: 'radial-gradient(circle, rgba(245, 87, 108, 0.3) 0%, rgba(245, 87, 108, 0) 70%)',
        borderRadius: '50%',
        pointerEvents: 'none'
      }}></div>

      <div style={{ width: '80%', maxWidth: '1600px', margin: '0 auto' }}>
        <div className="row justify-content-center">
          <div className="col-12">
            {/* ヘッダー */}
            <div className="text-center" style={{ marginBottom: '60px' }}>
              <h1 style={{
                fontSize: '64px',
                fontWeight: '700',
                lineHeight: '1.2',
                marginBottom: '30px',
                color: '#1a1a1a'
              }}>
                画面を作りながら見積もり可能です
              </h1>
              <p style={{
                fontSize: '22px',
                color: '#666',
                marginBottom: '0',
                lineHeight: '1.6'
              }}>
                作りたいアプリのアイデアを入力するだけで、<br />
                画面設計と開発費用の見積もりが瞬時に完成します。
              </p>
            </div>

            {/* 入力エリア */}
            <div style={{
              background: 'rgba(255, 255, 255, 0.5)',
              backdropFilter: 'blur(30px)',
              WebkitBackdropFilter: 'blur(30px)',
              borderRadius: '40px',
              padding: '80px 70px',
              boxShadow: '0 30px 80px rgba(0, 0, 0, 0.12)',
              marginBottom: '50px',
              border: '1px solid rgba(255, 255, 255, 0.6)'
            }}>
              <div style={{ position: 'relative', marginBottom: '50px' }}>
                <textarea
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  placeholder="どんなアプリを制作しますか？"
                  style={{
                    width: '100%',
                    height: '300px',
                    padding: '35px 140px 35px 35px',
                    fontSize: '24px',
                    border: 'none',
                    borderRadius: '24px',
                    outline: 'none',
                    background: 'rgba(255, 255, 255, 0.9)',
                    boxShadow: '0 8px 30px rgba(0, 0, 0, 0.08)',
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                    resize: 'none',
                    lineHeight: '1.5'
                  }}
                />
                <button
                  style={{
                    position: 'absolute',
                    right: '25px',
                    bottom: '25px',
                    width: '80px',
                    height: '80px',
                    background: '#FFBD59',
                    border: 'none',
                    borderRadius: '20px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.3s',
                    boxShadow: '0 6px 20px rgba(255, 189, 89, 0.4)'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = '#E89F30';
                    e.target.style.transform = 'scale(1.05)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = '#FFBD59';
                    e.target.style.transform = 'scale(1)';
                  }}
                >
                  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </div>

              {/* 人気のカテゴリー */}
              <div style={{ marginTop: '30px' }}>
                <p style={{
                  fontSize: '14px',
                  color: '#999',
                  marginBottom: '15px',
                  fontWeight: '500'
                }}>
                  人気のカテゴリー：
                </p>
                <div style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '10px'
                }}>
                  {popularCategories.map((category, index) => (
                    <button
                      key={index}
                      onClick={() => setInputValue(category)}
                      style={{
                        padding: '10px 20px',
                        background: '#f5f5f5',
                        border: '1px solid #e0e0e0',
                        borderRadius: '50px',
                        fontSize: '14px',
                        color: '#666',
                        cursor: 'pointer',
                        transition: 'all 0.3s',
                        fontWeight: '500'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.background = '#FFBD59';
                        e.target.style.color = 'white';
                        e.target.style.borderColor = '#FFBD59';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.background = '#f5f5f5';
                        e.target.style.color = '#666';
                        e.target.style.borderColor = '#e0e0e0';
                      }}
                    >
                      {category}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            {/* 利用者情報 */}
            <div className="text-center">
              <div style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '15px',
                padding: '15px 30px',
                background: 'white',
                borderRadius: '50px',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.06)'
              }}>
                <div style={{ display: 'flex', marginRight: '5px' }}>
                  <div style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    marginLeft: '-8px',
                    border: '2px solid white'
                  }}></div>
                  <div style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                    marginLeft: '-8px',
                    border: '2px solid white'
                  }}></div>
                  <div style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                    marginLeft: '-8px',
                    border: '2px solid white'
                  }}></div>
                </div>
                <p style={{
                  margin: '0',
                  fontSize: '15px',
                  color: '#666',
                  fontWeight: '500'
                }}>
                  世界中ユーザー数 <span style={{ color: '#1a1a1a', fontWeight: '700' }}>67人</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EstimatePage;
